import { connect } from 'react-redux';
import PhotoVideo from '../components/PhotoVideo';
import { FETCH_PHOTOS_RT } from './../actions/photovideo.actions';

const mapStateToProps = state => ({
    docs: state.photovideo.docs
});

const mapDispatchToProps = (dispatch) => {
    dispatch(FETCH_PHOTOS_RT());
    return {};
};

const HomeContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PhotoVideo);

export default HomeContainer;



// WEBPACK FOOTER //
// ./src/containers/PhotoVideo.container.js